<template>
  <div class="f14-l19 df18-l23  h-100">
    <div class="d-flex flex-column justify-content-center h-100" :class="claz">
      <div class="align-items-center d-flex flex-row position-relative">
        <img src="@/assets/phone-icon.svg" style="height: 14px;" class="spacer-left-small" />
        <div class="accordion-header pointer" @click="showPopup">{{contact.label_text}}</div>
        <CaretComponent :open="popupVisible" @click="showPopup" />
        <div v-show="popupVisible">
          <div class="d-flex flex-column innerpopup ">
            <table border="0">
              <tr v-if="contact.phone">
                <td>
                  <SvgImage :src="contact.phone.icon" />
                </td>
                <td class="padding-5 nowrap text-right">{{contact.phone.text}}</td>
                <td class="padding-5 nowrap text-left"><a class="black-link bold" :href="`tel:` + contact.phone.phone">{{contact.phone.phone}}</a></td>
              </tr>
              <tr v-if="contact.email">
                <td>
                  <SvgImage :src="contact.email.icon" />
                </td>
                <td class="padding-5 nowrap text-right">{{contact.email.text}}</td>
                <td class="padding-5 nowrap text-left"><a class="black-link bold" :href="`mailto:` + contact.email.email">{{contact.email.email}}</a></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <BGClickCatcherComponent v-show="popupVisible" @click="showPopup" />
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import SvgImage from "@/components/generic/SvgImage";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
export default {
  components: {
    SvgImage,
    CaretComponent,
    BGClickCatcherComponent
  },
  data() {
    return {
      popupVisible: false,
      showit: false
    }
  },
  props: {
    contact: Object
  },
  methods: {
    showPopup() {
      this.popupVisible = !this.popupVisible;
    },
  },
  computed: {
    claz() {
      if (this.$isDesktop()) {
        return "align-items-center";
      }
      return "align-items-right";
    }
  }
}
</script>
<style scoped>
.asmessage {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 0 5px 0 5px;
}

.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

.carousel .innerpopup {
  top: inherit;
  bottom: 25px;
}

.small-space {
  margin-right: 5px;
}
</style>